import { TutorialStep } from "..";

// 튜토리얼 시작 시 가장 오래된 프로젝트로 바로 진입시키므로 #main-card-list 스텝은 없앴다.
export const EnterProjectSteps: TutorialStep[] = [
  // 서버 선택 모달은 모듈 조회 응답 뒤에 뜬다. 안 뜨는 프로젝트에서는 이 스텝이 통째로 건너뛰어진다.
  {
    target: "#skip-select-server",
    content: "리포트 생성시엔 서버 선택이 불필요합니다.\n'서버 선택없이 진행하기'를 눌러주세요.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "top",
    disableOverlayClose: true,
  },
  {
    target: "#open-menu-btn",
    content: "상단 메뉴 버튼을 클릭합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#menu-list",
    content: "상단버튼을 클릭하여 리포트 페이지로 접근합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
